module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/type01.e3931a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/type01.jpg
// module id = UjJR
// module chunks = 0